import { render } from "./fieldTabs.vue?vue&type=template&id=5826acca&scoped=true"
import script from "./fieldTabs.vue?vue&type=script&lang=js"
export * from "./fieldTabs.vue?vue&type=script&lang=js"

import "./fieldTabs.vue?vue&type=style&index=0&id=5826acca&scoped=true&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5826acca"]])

export default __exports__